import { mapActions, mapMutations, mapGetters, mapStates } from './../baseModule'

const collection = 'manufacturers'
const singleName = 'manufacturer'
const pluralName = 'manufacturers'
const connection = 'config'

const model = {
  name: '',
  informativeText: ''
}

const validations = {
  name: {
    required: true,
    min: 5
  },
  informativeText: {
    required: true,
    min: 5,
    max: 600
  }
}

let getters = {...mapGetters()}
getters[singleName] = state => state.one
getters[pluralName] = state => state.all
getters = Object.assign(getters, {
  loading: state => state.loading,
  validations: state => state.validations,
  count: state => state.count
})

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    count: 0
  },
  mutations: {
    ...mapMutations()
  },
  actions: {
    ...mapActions(collection, model, connection)
  },
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/manufacturers.js